// Default TanStack Query client options.
// See react-rewrite-plan.md sections 6.3 and 11.4 query-provider.
//
// Why these defaults are conservative:
// - staleTime: 30s keeps screens stable for half-a-minute after a fetch.
//   Refetching too aggressively makes the UI flicker and surprises users
//   who already see the data they need. Individual entity hooks opt into
//   shorter staleTime when they have a real reason (e.g. live status).
// - retry: 1 catches transient blips without burning into a 4-retry storm
//   on a real outage. The shared API client already marks 5xx as
//   retryable; query layers can read that flag in the future to gate
//   retries by error class.
// - refetchOnWindowFocus: false avoids the well-known "tab back, page
//   reloads" experience that React Query enables by default. Specific
//   real-time screens can re-enable it.
// - mutations: retry: 0 — never silently re-run a mutation; the user
//   should re-confirm.

import type { DefaultOptions } from '@tanstack/react-query';

export const defaultQueryClientOptions: DefaultOptions = {
  queries: {
    staleTime: 30_000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
  mutations: {
    retry: 0,
  },
};
